module.exports = __webpack_public_path__ + "static/media/edesur.4c767251.png";